module.exports = __webpack_public_path__ + "assets/ic-cointelegraph.50f3cdd8.svg";